import { render, staticRenderFns } from "./layer_2.vue?vue&type=template&id=72bbd979&scoped=true"
import script from "./layer_2.vue?vue&type=script&lang=js"
export * from "./layer_2.vue?vue&type=script&lang=js"
import style0 from "./layer_2.vue?vue&type=style&index=0&id=72bbd979&prod&scoped=true&lang=css"
import style1 from "./layer_2.vue?vue&type=style&index=1&id=72bbd979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bbd979",
  null
  
)

export default component.exports